import React from 'react'
import { connect } from 'react-redux'
import { Page, PageHeader, AddPageContent } from '../src/ui'
import { AllCategoriesWithLetters } from '../src/modules/categories/components'
import { fetchCategories, fetchCategoriesWithGroups } from '../src/modules/categories/actions'
import initialState from '../src/modules/redux/initialState'
import { deepCopy } from '../src/utils'
import config from '../src/config/config.yaml'

class Categories extends React.Component {
  static async getInitialProps({ store, query}) {
    const targetPage = query.targetPage

    await Promise.all([
      store.dispatch(fetchCategories()),
      store.dispatch(fetchCategoriesWithGroups())
    ])

    return {
      title: `${config.pages.categories.title} | ${config.pages.defaultTitle}`,
      targetPage,
      state: Categories.getPageState(store)
    }
  }

  static getPageState(store) {
    const state = deepCopy(initialState)
    if (store) {
      const currentState = store.getState()

      state.user.auth.isAuthorized = currentState.user.auth.isAuthorized
      state.user.profile.error = currentState.user.profile.error
      state.user.profile.info = currentState.user.profile.info
      state.user.profile.favouriteAds = currentState.user.profile.favouriteAds
      state.user.profile.savedFilters = currentState.user.profile.savedFilters
      state.user.profile.favouriteProfiles = currentState.user.profile.favouriteProfiles
      state.user.listSidebar = currentState.user.listSidebar

      state.common.transitions = currentState.common.transitions
      state.common.router = currentState.common.router
      state.common.is404 = false
      state.common.userTypes = currentState.common.userTypes
      state.common.selectableUserTypes = currentState.common.selectableUserTypes
      state.common.isMobileDevice = currentState.common.isMobileDevice
      state.common.pageMetaTags = currentState.common.pageMetaTags
      state.common.pageMetaTagsSingle = currentState.common.pageMetaTagsSingle

      state.groups.elements = currentState.groups.elements

      state.geoObjects.countries = currentState.geoObjects.countries
      state.geoObjects.regions = currentState.geoObjects.regions
      state.geoObjects.cities = currentState.geoObjects.cities

      state.categories.elements = currentState.categories.elements
      state.categories.withGroups = currentState.categories.withGroups
      state.categories.bySeo = currentState.categories.bySeo
      state.categories.similarWords = currentState.categories.similarWords
      state.categories.parentCategories = currentState.categories.parentCategories

      state.ads.sms = currentState.ads.sms

      state.form = currentState.form

      state.cart = currentState.cart
      state.orders = currentState.orders
    }
    return state
  }

  render() {
    const { targetPage } = this.props

    let baseHref = '/category'
    let baseAs = '/'

    if (targetPage === 'mobilna-pretraga') {
      baseHref = '/mobileAdFilter'
      baseAs = '/mobilna-pretraga/'
    }

    return (
      <Page>
        <PageHeader>Sve kategorije</PageHeader>
        <AddPageContent title='Sve kategorije' description='Izaberite kategoriju oglasa za predmet koji tražite...'>
          <AllCategoriesWithLetters
            textSearchPlaceholder='upišite ovdje šta tražite... npr. Motor'
            baseHref={baseHref}
            baseAs={baseAs}
            parentCategoryInUrl
          />
        </AddPageContent>
      </Page>
    )
  }
}

export default connect(null)(Categories)
